import angular from "angular";

angular.module('app')
    .component('cabinetUserHistory', {
        template: require('./cabinet-user-history.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', 'moment', controller],
        bindings: {
            orders: '<'
        }
    });


function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {

    }

}



